"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _MessageContext = _interopRequireDefault(require("../../../context/MessageContext"));
var _updateCustomerAddress = _interopRequireWildcard(require("../../../utils/cart/updateCustomerAddress"));
var _getCustomerIdentifier = _interopRequireDefault(require("../../../utils/getCustomerIdentifier"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Headline = _interopRequireDefault(require("../../../components/views/Headline"));
var _Price = _interopRequireDefault(require("../../../components/Cart/Price"));
var _Addresses = _interopRequireDefault(require("../../../components/Addresses"));
var _Form = _interopRequireDefault(require("../../../components/Addresses/Form"));
var _TotalPrice = _interopRequireDefault(require("../../../components/Cart/TotalPrice"));
var _Addresses2 = _interopRequireDefault(require("./Addresses.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Addresses = _ref => {
  let {
    lang: defaultLang = "de",
    type: defaultType
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const {
    cart,
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const {
    address,
    isGuest = false,
    prices
  } = cart || {};
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const [type, setType] = (0, _react.useState)(defaultType !== null && defaultType !== void 0 ? defaultType : "shipping");
  const params = (0, _reactRouterDom.useParams)();
  const {
    type: _type
  } = params || {};
  const navigate = (0, _useLink.default)();
  const buttonRef = (0, _react.useRef)();
  const css = (0, _Addresses2.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const customerIdentifier = (0, _getCustomerIdentifier.default)();
  (0, _react.useEffect)(() => {
    if (!_type) return;
    setType(_type);
  }, [_type]);
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  const headline = (0, _react.useMemo)(() => {
    switch (type) {
      case "billing":
        return /*#__PURE__*/_react.default.createElement(_Local.default, {
          identifier: "reactShop.checkout.billingAddress.headline",
          l: l
        });
      case "guest":
        return /*#__PURE__*/_react.default.createElement(_Local.default, {
          identifier: "reactShop.checkout.guestAddress.headline",
          l: l
        });
      case "shipping":
        return /*#__PURE__*/_react.default.createElement(_Local.default, {
          identifier: "reactShop.checkout.shippingAddress.headline",
          l: l
        });
      default:
        return;
    }
  }, [l, type]);
  const selected = (0, _react.useMemo)(() => {
    var _ref2, _address$type$custome, _address$type, _address$shipping;
    return (_ref2 = (_address$type$custome = address === null || address === void 0 || (_address$type = address[type]) === null || _address$type === void 0 ? void 0 : _address$type.customerAddressID) !== null && _address$type$custome !== void 0 ? _address$type$custome : address === null || address === void 0 || (_address$shipping = address.shipping) === null || _address$shipping === void 0 ? void 0 : _address$shipping.customerAddressID) !== null && _ref2 !== void 0 ? _ref2 : 0;
  }, [address, type]);
  const handleSelect = async function (id, type) {
    let showMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const response = await (0, _updateCustomerAddress.default)({
      billingID: id,
      shippingID: id,
      type,
      customerIdentifier
    });
    const {
      msg
    } = response || {};
    if (msg) {
      setMessageObj({
        message: l("reactShop.messages.errors.".concat(_updateCustomerAddress.UPDATE_CUSTOMER_ADDRESS_ERRORS[msg])),
        type: "error"
      });
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    if (showMessage) {
      setMessageObj({
        message: l("reactShop.messages.success.CUSTOMER_ADDRESS_UPDATED"),
        type: "success"
      });
    }
  };
  const handleSubmit = async response => {
    const {
      data
    } = response || {};
    const {
      id = 0,
      msg
    } = data || {};
    if (msg) {
      return;
    }
    if (!isGuest) {
      await handleSelect(id, type, false);
      return;
    }
    if (data) {
      localStorage.setItem("mco-shop-cart", JSON.stringify(data));
      setCart(data);
    }
    navigate("/".concat(lang, "/shop/checkout"));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.addresses, "mco-shop-checkout-addresses")
  }, type && /*#__PURE__*/_react.default.createElement(_Headline.default, {
    headline: headline
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__right-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__price-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__price"
  }, /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang,
    prices: prices
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__total-price"
  }, /*#__PURE__*/_react.default.createElement(_TotalPrice.default, {
    lang: lang,
    prices: prices
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-checkout__content"
  }, defaultType ? /*#__PURE__*/_react.default.createElement(_Form.default, {
    buttonLabel: l("reactShop.addresses.buttons.save"),
    buttonRef: buttonRef,
    lang: lang,
    type: type,
    onSubmit: handleSubmit
  }) : /*#__PURE__*/_react.default.createElement(_Addresses.default, {
    buttonLabel: l("reactShop.addresses.buttons.save"),
    buttonRef: buttonRef,
    lang: lang,
    selected: selected,
    selectable: true,
    type: type,
    onSelect: id => handleSelect(id, type),
    onSubmit: handleSubmit
  }))));
};
var _default = exports.default = Addresses;